/**
 * Whether the `.dark` class is currently present on `<html>` — the same signal
 * the app's `dark:` Tailwind variant reacts to (set by `genDsDarkModeScript` in
 * config/app-index.ts). Returns `false` on the server.
 *
 * Exported so callers outside the React tree (e.g. the global tracking decorator)
 * can read the same signal without needing `useIsDarkMode`'s mount/observer lifecycle.
 */
export const isDarkModeApplied = (): boolean => {
	if (typeof document === 'undefined') return false; // SSR safety

	return document.documentElement.classList.contains('dark');
};
